import type { CSSProperties } from 'react';
import type { DefaultTheme } from 'styled-components';

export const getDateInputColor = (
  theme: DefaultTheme,
  {
    defaultColor,
    disabled,
    errorMessage,
  }: {
    defaultColor: string;
    disabled?: boolean;
    errorMessage?: string;
  }
): string => {
  if (disabled) return theme.palette.neutral[70];
  if (errorMessage) return theme.palette.error.main;
  return defaultColor;
};

export const getDateInputMantineStyles = (
  theme: DefaultTheme,
  {
    width,
    disabled,
    errorMessage,
  }: {
    width?: string;
    disabled?: boolean;
    errorMessage?: string;
  }
): Record<'wrapper' | 'label' | 'input' | 'calendarHeader', CSSProperties> => {
  const textColor = getDateInputColor(theme, {
    defaultColor: theme.palette.neutral[100],
    disabled,
    errorMessage,
  });
  const borderColor = getDateInputColor(theme, {
    defaultColor: theme.palette.neutral[90],
    disabled,
    errorMessage,
  });

  return {
    wrapper: {
      width: width ?? theme.input.date.width,
      maxWidth: '100%',
    },
    label: {
      color: textColor,
      ...theme.typography.bodySm2,
    },
    input: {
      height: theme.input.date.height,
      borderRadius: theme.borderRadius.sm,
      border: `0.5px solid ${borderColor}`,
      color: textColor,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ...theme.typography.bodyMd1,
    },
    calendarHeader: {
      textDecoration: 'underline',
    },
  };
};
